<template>
  <div>
    <h5>{{fecha}}</h5>
    <div class="hora">
      <span class="hora__ticker"> {{hora}} </span> <span class="hora__ticker-posfix">hrs.</span>
    </div>
  </div>
</template>
<script>
import { mapActions} from 'vuex';
import { formatDateForHumans, getCurrentTime } from '../services/utils';
export default {
  name: 'Clock',
  data(){
    return {
      date: new Date,
      time: getCurrentTime(),
      intervalID: null
    };
  },
  methods: {
    ...mapActions(['createUser']),
    stopClock(){
      clearInterval(this.intervalID);
    }
  },
  computed: {
    fecha(){ return formatDateForHumans(this.date.toISOString()); },
    hora:{
      get: function(){ 
        return this.time;
      },
      set: function(time){
        this.time = time;
      }
    },
  },
  created(){
    var self = this;
    this.intervalID = setInterval(function() {
      self.$data.time = getCurrentTime(); 
      // self.$data.time = Date.now(); 
    }, 1000);
  },
  beforeDestroy(){
    this.stopClock();
  }
}
</script>
<style lang="scss" scoped>
.hora{
  font-family: 'Orbitron', Consolas, Roboto, 'Courier New', sans-serif;
  color: rgb(28, 100, 100);
  font-size: 20px;
  font-weight: 700;
  /* text-shadow: 0 0 20px rgb(28, 100, 100),  0 0 20px rgba(10, 175, 230, 0); */
  display: flex;
  &__ticker{
    min-width: 120px;
  }
}
</style>